import { create } from 'zustand';

import type { TouchEditState } from './touchEdit.types';

export const useTouchEditStore = create<TouchEditState>()(set => ({
	visible: false,
	toggleVisible: () => set(state => ({ visible: !state.visible })),
	hideVisible: () => set({ visible: false })
}));
